export default __webpack_public_path__ + "static/media/checklist-green-64.21c5538b.png";